import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#B68A35",
            hover: "#C59850",
            text: "#1A1A1A",
        },
        secondary: {
            main: "#29241F",
            text: "#C59850",
        },
        background: {
            default: "#F8F6F2",
            paper: "#FFFFFF",
            section: "#E8E1D4",
        },
        border: "#E8E1D4",
        boxShadow: "0px 4px 4px 0px #A77D4336",
    },
    typography: {
        fontFamily: '"DIN Next LT Arabic", "Roboto", sans-serif',
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 700 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
        body1: { fontWeight: 400 },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#F8F6F2",
                },
            },
        },
    },
});

export default theme;
